import { useEffect, useState, useRef, type FormEvent, type ReactNode } from 'react';
import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
  Pause,
  LayoutDashboard,
  Gamepad2,
  BarChart3,
  MessageSquare,
  Users,
  Settings2,
  ScrollText,
  ArrowUpRight,
  LogOut,
  RefreshCw,
  Plus,
  Package,
  FileCode2,
  Search,
  MoreHorizontal,
  UploadCloud,
  Play,
  Archive,
  RotateCcw,
  Eye,
  EyeOff,
  ArrowRight,
  Check,
  Activity,
  HardDrive,
  Clock3,
  Star,
  Shield,
  ChevronRight,
  FolderOpen,
} from 'lucide-react';
import type { Analytics, Game, GameVersion, Feedback, User, Settings } from '../../../shared/types';
import { api, json, date, bytes } from '../../api';
import { usePlatform } from '../../store';
import { GameArt } from '../../components/GameCard';
import { Modal } from '../../components/Modal';
export function useLoad<T>(path: string) {
  const requestId = useRef(0);
  const [value, setValue] = useState<T | null>(null),
    [error, setError] = useState(''),
    [loading, setLoading] = useState(true);
  async function reload() {
    const id = ++requestId.current;
    setLoading(true);
    try {
      const result = await api<T>(path);
      if (id !== requestId.current) return;
      setValue(result);
      setError('');
    } catch (e) {
      if (id === requestId.current) setError((e as Error).message);
    } finally {
      if (id === requestId.current) setLoading(false);
    }
  }
  useEffect(() => {
    void reload();
    return () => {
      requestId.current++;
    };
  }, [path]);
  return { value, error, loading, reload };
}
export function AdminHeading({
  kicker,
  title,
  children,
}: {
  kicker?: string;
  title: string;
  children?: ReactNode;
}) {
  return (
    <div className="admin-heading">
      <div>
        {kicker && <div className="eyebrow">{kicker}</div>}
        <h1>{title}</h1>
      </div>
      <div className="heading-actions">{children}</div>
    </div>
  );
}
export function LoadError({ error }: { error: string }) {
  return error ? (
    <div className="notice error" role="alert">
      {error}
    </div>
  ) : null;
}
